var map = {
	"./images/after-dice.png": 1090,
	"./images/amulet_01.png": 1091,
	"./images/amulet_02.png": 1092,
	"./images/amulet_03.png": 1093,
	"./images/amulet_04.png": 1094,
	"./images/amulet_05.png": 1095,
	"./images/amulet_06.png": 1096,
	"./images/amulet_07.png": 1097,
	"./images/amulet_08.png": 1098,
	"./images/amulet_09.png": 1099,
	"./images/amulet_10.png": 1100,
	"./images/amulet_11.png": 1101,
	"./images/amulet_12.png": 1102,
	"./images/answer-a-pressed.png": 1103,
	"./images/answer-b-pressed.png": 1104,
	"./images/answer-buttions.png": 1105,
	"./images/answer-c-pressed.png": 1106,
	"./images/answer-correct.png": 1107,
	"./images/answer-wrong.png": 1108,
	"./images/attack-doubled.png": 1109,
	"./images/back.png": 1110,
	"./images/background.jpg": 1111,
	"./images/boos-question-start.png": 1112,
	"./images/boss-armor-red.png": 1113,
	"./images/boss-armor-yellow.png": 1114,
	"./images/boss-attack-boss.png": 1115,
	"./images/boss-attack-student.png": 1116,
	"./images/boss-back.png": 1117,
	"./images/boss-bar-red-01.png": 1118,
	"./images/boss-bar-red-02.png": 1119,
	"./images/boss-bar-red-03.png": 1120,
	"./images/boss-bar-red-04.png": 1121,
	"./images/boss-bar-red-05.png": 1122,
	"./images/boss-bar-red-06.png": 1123,
	"./images/boss-bar-red-07.png": 1124,
	"./images/boss-bar-red-08.png": 1125,
	"./images/boss-bar-red-09.png": 1126,
	"./images/boss-bar-red-10.png": 1127,
	"./images/boss-bar-red-11.png": 1128,
	"./images/boss-bar-yellow-01.png": 1129,
	"./images/boss-bar-yellow-02.png": 1130,
	"./images/boss-bar-yellow-03.png": 1131,
	"./images/boss-bar-yellow-04.png": 1132,
	"./images/boss-bar-yellow-05.png": 1133,
	"./images/boss-bar-yellow-06.png": 1134,
	"./images/boss-bar-yellow-07.png": 1135,
	"./images/boss-bar-yellow-08.png": 1136,
	"./images/boss-bar-yellow-09.png": 1137,
	"./images/boss-bar-yellow-10.png": 1138,
	"./images/boss-bar-yellow-11.png": 1139,
	"./images/boss-clear.png": 1140,
	"./images/boss-double-attack.png": 1141,
	"./images/boss-hidden-power-block-atk.png": 1142,
	"./images/boss-hidden-power-block-def.png": 1143,
	"./images/boss-hidden-power-block-hp.png": 1144,
	"./images/boss-hidden-power-block-not-select.png": 1145,
	"./images/boss-hidden-power-block.png": 1146,
	"./images/boss-item-block.png": 1147,
	"./images/boss-item-border.png": 1148,
	"./images/boss-item-empty.png": 1149,
	"./images/boss-number-red-0.png": 1150,
	"./images/boss-number-red-1.png": 1151,
	"./images/boss-number-red-2.png": 1152,
	"./images/boss-number-red-3.png": 1153,
	"./images/boss-number-red-4.png": 1154,
	"./images/boss-number-red-5.png": 1155,
	"./images/boss-number-red-6.png": 1156,
	"./images/boss-number-red-7.png": 1157,
	"./images/boss-number-red-8.png": 1158,
	"./images/boss-number-red-9.png": 1159,
	"./images/boss-number-yellow-0.png": 1160,
	"./images/boss-number-yellow-1.png": 1161,
	"./images/boss-number-yellow-2.png": 1162,
	"./images/boss-number-yellow-3.png": 1163,
	"./images/boss-number-yellow-4.png": 1164,
	"./images/boss-number-yellow-5.png": 1165,
	"./images/boss-number-yellow-6.png": 1166,
	"./images/boss-number-yellow-7.png": 1167,
	"./images/boss-number-yellow-8.png": 1168,
	"./images/boss-number-yellow-9.png": 1169,
	"./images/boss-remember-block.png": 1170,
	"./images/boss-student-bg.png": 1171,
	"./images/boss-tuagom-pic-starting.png": 1172,
	"./images/boss-tuagom-pic.png": 1173,
	"./images/broken-shield.png": 1174,
	"./images/coming-soon.png": 1175,
	"./images/fight.png": 1176,
	"./images/home.png": 1177,
	"./images/image-default.png": 1178,
	"./images/lock-dialog.png": 1179,
	"./images/lock.png": 1180,
	"./images/lose.png": 1181,
	"./images/not-fighting-power.png": 1182,
	"./images/not-search-power.png": 1183,
	"./images/player-attacking.png": 1184,
	"./images/player-broken-shield.png": 1185,
	"./images/power-all1.png": 1186,
	"./images/power-all2.png": 1187,
	"./images/power-all3.png": 1188,
	"./images/power-all5.png": 1189,
	"./images/power-atk1.png": 1190,
	"./images/power-atk2.png": 1191,
	"./images/power-atk3.png": 1192,
	"./images/power-atk5.png": 1193,
	"./images/power-def1.png": 1194,
	"./images/power-def2.png": 1195,
	"./images/power-def3.png": 1196,
	"./images/power-def5.png": 1197,
	"./images/power-hp15.png": 1198,
	"./images/power-hp3.png": 1199,
	"./images/power-hp5.png": 1200,
	"./images/power-hp7.png": 1201,
	"./images/power-none.png": 1202,
	"./images/question-button-press-a.png": 1203,
	"./images/question-button-press-b.png": 1204,
	"./images/question-button-press-c.png": 1205,
	"./images/question-button.png": 1206,
	"./images/rank-a.png": 1207,
	"./images/rank-b.png": 1208,
	"./images/rank-c.png": 1209,
	"./images/rank-d.png": 1210,
	"./images/rank-e.png": 1211,
	"./images/rank-s.png": 1212,
	"./images/roll-dice-10.png": 1213,
	"./images/roll-dice-100.png": 1214,
	"./images/roll-dice-20.png": 1215,
	"./images/roll-dice-30.png": 1216,
	"./images/roll-dice-40.png": 1217,
	"./images/roll-dice-50.png": 1218,
	"./images/roll-dice-60.png": 1219,
	"./images/roll-dice-70.png": 1220,
	"./images/roll-dice-80.png": 1221,
	"./images/roll-dice-90.png": 1222,
	"./images/roll-dice-before.png": 1223,
	"./images/roll-dice.png": 1224,
	"./images/select.png": 1225,
	"./images/stage-locked.png": 1226,
	"./images/unselect.png": 1227,
	"./images/video-power-searching.png": 1228,
	"./images/video-yardnapha-issue-one.png": 1229,
	"./images/video-yardnapha-issue-two.png": 1230,
	"./images/video-yardnapha-issue.png": 1231,
	"./images/video-yardnapha-off.png": 1232,
	"./images/video-yardnapha-on.png": 1233,
	"./images/video-yardnapha-runoff.png": 1234,
	"./images/walk.png": 1235,
	"./images/win-normal-boss.png": 1236,
	"./images/win-reward-A01.png": 1237,
	"./images/win-reward-A02.png": 1238,
	"./images/win-reward-A03.png": 1239,
	"./images/win-reward-A04.png": 1240,
	"./images/win-reward-A05.png": 1241,
	"./images/win-reward-A06.png": 1242,
	"./images/win-reward-A07.png": 1243,
	"./images/win-reward-A08.png": 1244,
	"./images/win-reward-A09.png": 1245,
	"./images/win-reward-A10.png": 1246,
	"./images/win-reward-A11.png": 1247,
	"./images/win-reward-A12.png": 1248,
	"./images/win.png": 1249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1089;